import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { analytics } from '../analytics'

export function usePageTracking(): void {
  const location = useLocation()

  useEffect(() => {
    analytics.track('page_view', {})
  }, [location.pathname, location.search])
}
